import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams, AlertController } from 'ionic-angular';
import {TeamappProvider} from "../../providers/teamapp";
import {UserProvider} from "../../providers/user";
import {LoadingProvider} from "../../providers/loading";
import { FileTransfer, FileTransferObject } from '@ionic-native/file-transfer';
import { File } from '@ionic-native/file';
import { FileOpener } from '@ionic-native/file-opener';


/**
 * Generated class for the FileReadPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
  selector: 'page-file-read',
  templateUrl: 'file-read.html',
})
export class FileReadPage {

  title: string = 'Dokument';
  fileInput: any;
  input: any;
  pdf_path: string = 'https://app.fw-wesling.de/uploads/files/';
  constructor(public loadingProvider: LoadingProvider, public alertCtrl: AlertController, public userProvider: UserProvider, public navCtrl: NavController, public navParams: NavParams, public teamappProvider: TeamappProvider, private transfer: FileTransfer, private file: File, private fileOpener: FileOpener) {
    this.fileInput = this.navParams.get('file');
    this.title = this.fileInput.title;
  }

  setAsRead() {

  }

  requireAccept() {
    if(this.fileInput.requireType == 'confirm') {
      let alert = this.alertCtrl.create({
        title: 'Bestätigen',
        message: 'Dieses Dokument benötigt eine Lesebestätigung für den Arbeitgeber. Soll diese jetzt abgegeben werden?',
        buttons: [
          {
            text: 'Abbrechen',
            role: 'cancel',
            handler: () => {
              console.log('Cancel clicked');
            }
          },
          {
            text: 'Bestätigen',
            handler: () => {
              this.teamappProvider.http_request('action=confirm_document&document_id='+this.fileInput.id+'&document_input=confirm', 'files', false, true).then(data => {
                console.log("DATA =>>>");
                console.log(data);
                let alert = this.alertCtrl.create({
                  title: 'Erfolgreich',
                  message: 'Das Dokument '+this.fileInput.title+' wurde erfolgreich bestätigt.',
                  buttons: [
                    {
                      text: 'OK',
                      role: 'cancel',
                      handler: () => {
                        console.log('Cancel clicked');
                      }
                    },
                  ]
                });
                alert.present();
                this.navCtrl.pop();
              });
            }
          }
        ]
      });
      alert.present();
    } else if(this.fileInput.requireType == 'input') {
      let alert = this.alertCtrl.create({
        title: 'Bestätigung',
        inputs: [
          {
            name: 'input',
            placeholder: 'Eingabe'
          }
        ],
        buttons: [
          {
            text: 'Abbrechen',
            role: 'cancel',
            handler: data => {
              console.log('Cancel clicked');
            }
          },
          {
            text: 'Eingabe übergeben',
            handler: data => {
              if(!data.input) {
                this.requireAccept();
              } else {
                this.input = data.input;
                this.teamappProvider.http_request('action=confirm_document&document_id='+this.fileInput.id+'&document_input='+this.input, 'files', false, true).then(data => {
                  console.log("DATA =>>>");
                  console.log(data);
                  let alert = this.alertCtrl.create({
                    title: 'Erfolgreich',
                    message: 'Das Dokument '+this.fileInput.title+' wurde erfolgreich mit der Eingabe '+this.input+' bestätigt.',
                    buttons: [
                      {
                        text: 'OK',
                        role: 'cancel',
                        handler: () => {
                          console.log('Cancel clicked');
                        }
                      },
                    ]
                  });
                  alert.present();
                  this.navCtrl.pop();
                });
              }
            }
          }
        ]
      });
      alert.present();
    }
  }

  openPDF(document_name,id, fileUrl){
    //window.open(this.pdf_path+fileUrl,'_system','location=yes'),!1;
    const fileTransfer: FileTransferObject = this.transfer.create();
    this.loadingProvider.show();
    fileTransfer.download(this.pdf_path + fileUrl, this.file.dataDirectory + 'file-'+id+'.pdf').then((entry) => {
      this.loadingProvider.hide();
      this.fileOpener.open(entry.toURL(), 'application/pdf')
          .then(() => console.log('File is opened'))
          .catch(e => console.log('Error opening file', e));
    }, (error) => {
      // handle error
    });
  }
  
  ionViewDidLoad() {
    console.log('ionViewDidLoad FileReadPage');
  }

}



// WEBPACK FOOTER //
// ./src/pages/file-read/file-read.ts